import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const DocumentosFormGroup = ({ iError, iTouched, fIsSubmitting, documentosData, flagDocumentoSeleccionado }) => {
  return (
    <Form.Group>
      <Form.Label text='DOCUMENTO' htmlFor='select-documento' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='_idDocumentoRelacionado'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting || flagDocumentoSeleccionado} isInvalid={iTouched && iError} id='select-documento'>
              <option value=''>Seleccionar</option>
              {documentosData &&
                documentosData.map((val, key) => (
                  <option key={key} value={val._id}>
                    {`${val.fechaEmision}`} &emsp; &emsp; {`${val.tipoDocumento}-${val.serieDocumento}-${val.numeroDocumento}`}
                  </option>
                ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DocumentosFormGroup)
